import { Form } from 'antd';
import styled from 'styled-components';

export const LoginWrapper = styled.div`
    padding: 16px;
    height: 100vh;
    display: grid;
    align-content: center;
    justify-content: center;
    gap: 24px;
`;

export const LoginTitle = styled.h1`
    font-size: 22px;
    font-weight: 300;
`;

export const LoginForm = styled(Form)`
    min-width: 320px;
    max-width: 400px;
`;

export const LoginMessages = styled.div`
    min-width: 320px;
    max-width: 400px;
`;